import products_category from "../views/products_category/index.vue";
import products_category_create from "../views/products_category/create.vue";
import products_category_edit from "../views/products_category/edit.vue";
import products_category_detail from "../views/products_category/detail.vue";
import products_category_import from "../views/products_category/import.vue";

const routes = [
  {
    path: "/products_category",
    name: "products_category",
    component: products_category,
    meta: { authOnly: true }
  },
  {
    path: "/products_category/create",
    name: "products_category_create",
    component: products_category_create,
    meta: { authOnly: true }
  },
  {
    path: "/products_category/edit/:uuid",
    name: "products_category_edit",
    component: products_category_edit,
    meta: { authOnly: true }
  },
  {
    path: "/products_category/detail/:uuid",
    name: "products_category_detail",
    component: products_category_detail,
    meta: { authOnly: true }
  },
  {
    path: "/products_category/import",
    name: "products_category_import",
    component: products_category_import,
    meta: { authOnly: true }
  }
];

export default routes;
